import { Auth0Client } from "@auth0/auth0-spa-js";
import axios from "axios";
import { apiConfig, auth0Config } from "../../config";
import { FreeOption, FreeOptionQuery } from "../../types/freeOptions";
import querySearchEndpoint from "../../utils/querySearchEndpoint";
import { getAuthConfigWithProps, getBasicAuthConfig } from "../authUtils";

const urlPath = "free-options";

class FreeOptionsApi {
  private auth0Client: Auth0Client | null = null;

  constructor() {
    this.auth0Client = new Auth0Client({
      redirect_uri: window.location.origin,
      ...auth0Config,
    });
  }

  async getFreeOptions(
    query: FreeOptionQuery,
    signal?: AbortSignal,
  ): Promise<FreeOption[]> {
    const config = await getAuthConfigWithProps(
      this.auth0Client,
      signal ? { signal } : {},
    );

    const url = new URL(`${apiConfig.refDataServiceBase}/${urlPath}`);
    return querySearchEndpoint(url, query, config);
  }

  async createFreeOption(
    freeOption: Omit<FreeOption, "_id" | "active">,
  ): Promise<FreeOption> {
    const config = await getBasicAuthConfig(this.auth0Client);

    return axios
      .post(`${apiConfig.refDataServiceBase}/${urlPath}`, freeOption, config)
      .then((res) => res?.data);
  }

  async updateFreeOption(
    id: string,
    freeOption: Pick<FreeOption, "value">,
  ): Promise<FreeOption> {
    const config = await getBasicAuthConfig(this.auth0Client);
    return axios
      .put(
        `${apiConfig.refDataServiceBase}/${urlPath}/${id}`,
        freeOption,
        config,
      )
      .then((res) => res?.data);
  }

  async deleteFreeOption(id: string): Promise<void> {
    const config = await getBasicAuthConfig(this.auth0Client);
    return axios.delete(
      `${apiConfig.refDataServiceBase}/${urlPath}/${id}`,
      config,
    );
  }
}

const freeOptionApi = new FreeOptionsApi();

export default freeOptionApi;
